<app-replenish-your-good-bacteria>
  <p class="mb-4">
    Zofran (ondansetron) is highly effective at preventing nausea—but it often slows digestion, which can lead to
    <strong>unwanted side effects like constipation and bloating</strong>. A simple solution? Taking
    <strong>high-potency probiotics</strong> alongside your prescription.
  </p>
  <p class="mb-4">
    Probiotics help <strong>maintain regular digestion</strong> and <strong>support a healthy gut</strong> while your
    body adjusts to Zofran. By adding probiotics to your treatment plan, you're not just easing potential
    discomfort—you're also promoting better <strong>nutrient absorption</strong> and
    <strong>long-term digestive wellness</strong>.
  </p>
</app-replenish-your-good-bacteria>
